import { ClaimTypeCode } from '@quromedical/fhir-common';
import {
  ClaimTemplateCreateRequest,
  ClaimTemplateGetAllResponse,
  ClaimTemplateGetResponse,
  ClaimTemplateUpdateRequest,
  ClaimTemplateUpdateResponse,
} from '@quromedical/models';
import { trpc } from 'trpc';

export class ClaimTemplateApi {
  public async getClaimTemplates(): Promise<ClaimTemplateGetAllResponse> {
    return await trpc.client.claimTemplate.getAll.query();
  }

  public async getClaimTemplate(type: ClaimTypeCode): Promise<ClaimTemplateGetResponse> {
    return await trpc.client.claimTemplate.getByType.query({ type });
  }

  public async updateClaimTemplate(
    body: ClaimTemplateUpdateRequest
  ): Promise<ClaimTemplateUpdateResponse> {
    return await trpc.client.claimTemplate.update.mutate({
      ...body,
    });
  }

  public async createClaimTemplate(
    body: ClaimTemplateCreateRequest
  ): Promise<ClaimTemplateUpdateResponse> {
    return await trpc.client.claimTemplate.create.mutate({
      ...body,
    });
  }
}
